module.exports = __webpack_public_path__ + "static/img/ic_bus_on@2x.7d18ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bus_on@2x.png
// module id = YMnr
// module chunks = 1